// components
import BaseApi from "../../utils/BaseApi";
import CommonForm from "../Common/CommonForm";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TableViewIcon from "@mui/icons-material/TableView";


class OverheadPeriodicCreate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Создание расхода',
            buttonColor: 'primary',
            ready: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        return {
            modalLabel: 'Создание расхода',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async retrieveFields(){
        const url = `overhead/create_form/`;
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                fields: JSON.stringify(
                    [
                        'title',
                        'category',
                        'cost',
                        'pay_date',
                        'period',
                        'date_start_publish',
                        'date_end_publish',
                    ]
                )
            }
        );
        return(response.data)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        formDataObj.periodic = true;
        const url = `overhead/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            this.setModalOpenFalse();
            if (typeof this.props.callBack == 'function') {
                await this.props.callBack();
            }
        }
        return response
    }
}

export default OverheadPeriodicCreate